import { render, staticRenderFns } from "./ImageSizeProperty.vue?vue&type=template&id=f8f86202&"
import script from "./ImageSizeProperty.vue?vue&type=script&lang=js&"
export * from "./ImageSizeProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports